import { render } from "./MyPageNon.vue?vue&type=template&id=670507c3&scoped=true&ts=true"
import script from "./MyPageNon.vue?vue&type=script&lang=ts"
export * from "./MyPageNon.vue?vue&type=script&lang=ts"

import "./MyPageNon.vue?vue&type=style&index=0&id=670507c3&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-670507c3"]])

export default __exports__